export default __webpack_public_path__ + "static/media/ragingbull.a4cea064.png";